import { defineComponent as a, computed as t } from "vue";
const u = /* @__PURE__ */ a({
  __name: "charger-label",
  props: {
    pd: { type: Boolean, default: !1 },
    watts: { type: String, default: null }
  },
  setup(r) {
    const e = r, n = t(() => e.pd === !0 ? "USB PD" : "USB"), o = t(() => [
      "USB",
      e.pd === !0 ? "Power Delivery" : void 0,
      "Leistung:",
      `${e.watts} Watt`
    ].filter(Boolean).join(" "));
    return { __sfc: !0, props: e, subText: n, label: o };
  }
});
export {
  u as default
};
